import utilService from '../../services/UtilService';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import questionReader from '../../store/readHelpers/QuestionReader';
import scorableItemReader from '../../store/readHelpers/ScorableItemReader';

const sectionAnswerKeysSelector = {
    prepareItemAnswerKeys(item, index, question) {
        const answerKeys = assessmentReader.getCorrectResponse(item);
        if (!answerKeys) {
            return null;
        }

        const isMatching = questionReader.isMatchingQuestion(question) || questionReader.isGapMatchQuestion(question);

        return {
            contentRevisionId: item.contentRevisionId,
            isMatchingQuestion: isMatching,
            itemIndex: index,
            keys: answerKeys,
            orderNumber: item.orderNumber,
        };
    },

    selectSectionAnswerKeys({ questions }) {
        const sectionAnswerKeys = questions.map(question => (
            scorableItemReader.getScorableItemsInQuestion(question.contentRevisionId)
                .map((item, index) => this.prepareItemAnswerKeys(item, index, question))
                .filter(sectionKeys => !!sectionKeys)
        ));

        return utilService.flatArray(sectionAnswerKeys);
    },

    selectProps({ section }) {
        return {
            sectionAnswerKeys: this.selectSectionAnswerKeys(section),
            sectionTitle: scorableItemNumberingService.getSectionFormatNumber(section.id, section.customFields),
        };
    },
};

export default sectionAnswerKeysSelector;
